<div class="modal__header">
	<h2 class="title" id="modal__title">{{ 'modals.hotel.text.hotel' | ibeadmin | async }}</h2>
	<div class="modal__header-actions">
		<button aria-label="Close dialog" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>
<div class="modal__body sl--scrollable">
	<div class="modal__text">
		<strong>{{ 'modals.hotel.text.areYouStillHere' | ibeadmin | async }}</strong>
		<p>{{ 'modals.hotel.text.areYouLookingForHotel' | ibeadmin | async }} {{ destinationCity }}{{ 'modals.hotel.text.weCanHelpYou' | ibeadmin | async }}</p>
	</div>

	<div id='c_container' class="hotel-iframe"
		[title]="('modals.hotel.text.seekAccomodation' | ibeadmin | async) + ' ' + this.destinationForHotel" 
		[attr.aria-label]="('modals.hotel.text.seekAccomodation' | ibeadmin | async) + ' ' + this.destinationForHotel"
	></div>
</div>